export const handleThinkingChunk = (message: any, currentMessageRef: any, llmRequestRefs: any, setMessages: any) => {
    // Clear the content if this is the first chunk
    if (llmRequestRefs.current.intervalId) {
        clearInterval(llmRequestRefs.current.intervalId);
        llmRequestRefs.current.intervalId = null;
        currentMessageRef.current.message = {
            ...currentMessageRef.current.message,
            content: []
        };
    }

    let updatedContent = [...currentMessageRef.current.message.content];
    if (updatedContent.length === 0) {
        updatedContent.push({type: "thinking", thinking: message.thinking});
    } else {
        const lastIndex = updatedContent.length - 1;
        const currentText = updatedContent[lastIndex]?.thinking || '';
        updatedContent[lastIndex] = {
            type: "thinking",
            thinking: currentText + message.thinking
        };
    }

    currentMessageRef.current.message = {
        ...currentMessageRef.current.message,
        content: updatedContent
    };

    setMessages((prev: any) => prev.deepCopy());
}

export const handleThinkingFinish = (message: any, currentMessageRef: any) => {
    let updatedContent = [...currentMessageRef.current.message.content];

    // Find the last thinking block to add signature to
    let foundThinkingIndex = -1;
    for (let i = updatedContent.length - 1; i >= 0; i--) {
        if (updatedContent[i]?.type === "thinking" && !updatedContent[i]?.signature) {
            foundThinkingIndex = i;
            break;
        }
    }

    // Only add signature if we found a thinking block without one
    if (foundThinkingIndex >= 0) {
        const currentText = updatedContent[foundThinkingIndex]?.thinking || '';
        updatedContent[foundThinkingIndex] = {
            type: "thinking",
            signature: message.signature,
            thinking: currentText
        };

        currentMessageRef.current.message = {
            ...currentMessageRef.current.message,
            content: updatedContent
        };
    }
}

export const handleThinkingRedacted = (message: any, currentMessageRef: any) => {
    let updatedContent = [...currentMessageRef.current.message.content];
    // Here there actually may be no previous CoT, so push a new element if needed
    if (updatedContent.length === 0) {
        updatedContent.push({type: "redacted_thinking", data: message.data});
    } else {
        const lastIndex = updatedContent.length - 1;
        updatedContent[lastIndex] = {
            type: "redacted_thinking",
            data: message.data
        };
    }
}
